import type { ListOrgHierarchyRelationsQuery } from '@/common/graphql';

export type OrgHierarchyRelationItem = ListOrgHierarchyRelationsQuery['listOrgHierarchyRelations']['items'][number];

/**
 * Returns true when the given item ID should be rendered as disabled based on
 * OrgHierarchyRelation rows.
 *
 * BU check  (forBuId === undefined):
 *   - No rows / any null businessUnit row → false (no restriction)
 *   - id not in any row                   → true
 *
 * Dept check (forBuId provided):
 *   - No rows / company or BU wildcard    → false (no restriction)
 *   - id not in BU's rows                 → true
 */
export function isDisabledByRelation(id: string, relations: OrgHierarchyRelationItem[], forBuId?: string): boolean {
  if (relations.length === 0) return false;

  if (forBuId === undefined) {
    if (relations.some(r => r.businessUnit === null)) return false;
    return !relations.some(r => r.businessUnit?.id === id);
  }

  if (relations.some(r => r.businessUnit === null)) return false;
  const buRows = relations.filter(r => r.businessUnit?.id === forBuId);
  if (buRows.length === 0) return false;
  if (buRows.some(r => r.department === null)) return false;
  return !buRows.some(r => r.department?.id === id);
}
